<template>
  <div class="filter-item-range w-full md:w-400px">
    <div class="label flex justify-between items-center text-base px-5 py-4 select-none">
      <span>{{ props.formatter(value[0]) }}</span>
      <span>{{ props.formatter(value[1]) }}</span>
    </div>
    <div class="slider-wrapper px-5 py-3">
      <n-slider v-model:value="value" range :step="props.step" :min="props.min" :max="props.max" :format-tooltip="props.formatter" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { NSlider } from 'naive-ui'

import type { SfilterOption } from '@/types/api'

const props = withDefaults(
  defineProps<{
    modelValue: [Nullable<number>, Nullable<number>]
    range: SfilterOption[]
    step?: number
    min?: number
    max?: number
    formatter?: (value: number) => string
  }>(),
  {
    step: 10,
    min: 0,
    max: 3000,
    formatter: (value: number) => `${value}`,
  }
)

const emit = defineEmits<{
  (event: 'update:modelValue', value: [Nullable<number>, Nullable<number>]): void
}>()

const value = computed<[number, number]>({
  get() {
    return [props.modelValue[0] ?? props.min, props.modelValue[1] ?? props.max]
  },
  set(value) {
    emit(
      'update:modelValue',
      // @ts-ignore-next-line
      value.sort((a, b) => Number(a) - Number(b)).map(v => (v === props.min || v === props.max ? null : v))
    )
  },
})
</script>

<style lang="scss" scoped></style>
